import { domToReact } from "html-react-parser"
import React from "react"

export const standardOptions = (dark, bigger) => {
  return {
    replace: element => {
      const { attribs, name, children } = element
      if (name === "p") {
        return (
          <p
            className={`
            ${dark ? "text-white" : "text-gray-500"}
            ${bigger ? "mt-4 text-lg" : ""}`}
          >
            {domToReact(children, standardOptions(dark, bigger))}
          </p>
        )
      }
      if (name === "ul") {
        return (
          <ul
            className={`my-0 flex flex-col gap-3 ${
              dark ? "marker:text-blue-600" : "marker:text-orangeSafe"
            } list-disc ml-4 mt-2`}
          >
            {domToReact(children, standardOptions(dark, bigger))}
          </ul>
        )
      }
      if (name === "li") {
        return (
          <li
            className={`my-0 text-md
            ${dark ? "text-white" : "text-gray-500"}
            ${bigger ? "text-lg" : ""}`}
          >
            {domToReact(children, standardOptions(dark, bigger))}
          </li>
        )
      }
      if (name === "span" && attribs?.style === "text-decoration: underline;") {
        return (
          <span className="text-cabaret-600 font-semibold">
            {domToReact(children, standardOptions(dark, bigger))}
          </span>
        )
      }
      return null
    },
  }
}
